<div class="modal-header">
  <h5 class="modal-title flex align-items-center">
    <i
      class="fa-solid fa-store me-2"
      style="color: #00549d; font-size: 1.5rem"
    ></i>
    <span style="font-size: 16px; color: #0063b9">Tiendas</span>
  </h5>
  <button type="button" class="btn" (click)="activeModal.close()">
    <i class="fas fa-times-circle" style="color: #00549d; font-size: 18px"></i>
  </button>
</div>

<div class="modal-body p-3" style="min-height: auto">
  <small class="fw-semibold" style="color: #0063b9">Tienda Actual</small>
  <h5 class="text-blue">{{ tienda.zone | uppercase }}</h5>
  <small class="fw-semibold" style="color: #0063b9; font-size: 14px"
    >Seleccione la tienda de su preferencia</small
  >
  <div class="mb-3">
    <select
      class="form-select w-100"
      aria-label="Default select example"
      [(ngModel)]="tiendaTemporal"
      name="tiendaTemporal"
    >
      <option [ngValue]="null">
        {{ 'Seleccione una tienda' | uppercase }}
      </option>
      <option *ngFor="let item of tiendas" [ngValue]="item">
        {{ item.zone | uppercase }}
      </option>
    </select>
    <div class="flex align-items-start mt-4" style="font-size: 12px">
      <i
        class="fa-regular fa-circle-info"
        style="margin-right: 5px; font-size: 16px; color: #0063b9"
      ></i>
      <p class="mb-0">
        Los precios de productos y despacho pueden variar según la ubicación de
        la tienda.
      </p>
    </div>
  </div>
</div>
<div class="modal-footer">
  <div class="row w-100">
    <div class="col-sm-4 flex"></div>
    <div class="col-sm-4 flex justify-content-end" style="margin-bottom: 10px">
      <button
        name="cancelar"
        class="btn btn-border-primary text-center btn-lg w-100"
        (click)="activeModal.close()"
      >
        Cancelar
      </button>
    </div>
    <div
      class="col-sm-4 flex justify-content-center"
      style="margin-bottom: 10px"
    >
      <button
        name="aceptar"
        class="btn btn-secondary text-center btn-lg w-100"
        (click)="cambiarTienda()"
      >
        Aceptar
      </button>
    </div>
  </div>
</div>
